import clsx from 'clsx'
import React, {
    type ReactNode,
    type ButtonHTMLAttributes,
} from 'react'
import styles from './Button.module.scss'
import {Spinner} from '../Spinner/index.ts'
import {AudioManager, AudioType} from '@colonist/audio'

export type ButtonProps = {
    variant?: 'primary' | 'secondary' | 'dark' | 'outline' | 'muted'
    size?: 'md' | 'sm'
    className?: string
    disabled?: boolean
    children?: ReactNode
    onClick?: VoidFunction
    fullWidth?: boolean
    isLoading?: boolean
    loaderClassName?: string
    noShadow?: boolean
} & ButtonHTMLAttributes<HTMLButtonElement>

export const Button = ({
    className = '',
    variant = 'primary',
    size = 'md',
    children,
    disabled = false,
    onClick,
    fullWidth,
    isLoading,
    loaderClassName,
    noShadow = false,
    ...props
}: ButtonProps) => (
    <button
        className={clsx(styles.button, {
            [styles.primary]: variant === 'primary',
            [styles.secondary]: variant === 'secondary',
            [styles.dark]: variant === 'dark',
            [styles.outline]: variant === 'outline',
            [styles.muted]: variant === 'muted',
            [styles.sm]: size === 'sm',
            [styles.disabled]: disabled || isLoading,
            [styles.fullWidth]: fullWidth,
            [styles.noShadow]: noShadow,
        }, className)}
        disabled={disabled}
        onClick={disabled || isLoading ? undefined : () => {
            AudioManager.play(AudioType.Click)
            onClick?.()
        }}
        {...props}
    >
        {isLoading && <Spinner className={clsx(styles.loader, loaderClassName)} />}
        {children}
    </button>
)
